const km = {
  nav: {
    home: "ទំព័រដើម",
    skillset: "ជំនាញ",
    projects: "គម្រោង",
    resume: "ប្រវត្តិរូប",
    contact: "ទំនាក់ទំនង",
  },
  themeToggle: {
    toDark: "ប្តូរទៅរបៀបងងឹត",
    toLight: "ប្តូរទៅរបៀបភ្លឺ",
  },
  langToggle: {
    label: "ភាសា",
  },
  preloader: {
    loading: "កំពុងផ្ទុក",
  },
  home: {
    greeting: "សួស្តី!",
    intro: "ខ្ញុំឈ្មោះ",
    name: "តូម៉ន",
    roles: [
      "អ្នកអភិវឌ្ឍន៍វេបសាយ",
      "អ្នករចនា UI/UX",
      "អ្នកសម្របសម្រួលបច្ចេកទេស GPS",
      "អ្នកបង្រៀន ICT",
      "ភ្នាក់ងារបច្ចេកទេស Hardware និង Software",
    ],
    tagline:
      "បរិញ្ញាបត្រ​ ជំនាញព័ត៌មានវិទ្យា នៅសកលវិទ្យាល័យ​ភូមិន្ទ ភ្នំពេញ​ មានចំណង់ចំណូលចិត្តក្នុងការបង្កើតកម្មវិធីវេប និងស្វែងយល់អំពីសន្តិសុខសាយប័រ។",
    ctaProjects: "មើលការងាររបស់ខ្ញុំ",
    ctaContact: "ទាក់ទងមកខ្ញុំ",
    photoAlt: "តូម៉ន",
    swapHint: "ចុច ឬដាក់ Mouse លើរូបខ្ញុំ",
    swapOn: "> access granted_",
    swapLabel: "ប្តូររវាងរូបថតខ្ញុំ និងរូប Avatar Hacker",
    scrollCue: "រំកិលចុះដើម្បីមើលបន្ថែម",
  },
  about: {
    label: "ព័ត៌មាន",
    heading: {
      a: "សូមឱ្យខ្ញុំ",
      highlight: "ណែនាំ",
      b: "ខ្លួនឯង",
    },
    paragraphs: [
      "សួស្តី ខ្ញុំឈ្មោះ តូម៉ន ស្រុកកំណើតនៅ ភ្នំពេញ ​បច្ចុប្បន្នរស់នៅខេត្តសៀមរាប ប្រទេសកម្ពុជា។",
      "ខ្ញុំជានិស្សិតឆ្នាំទី៤ ជំនាញបច្ចេកវិទ្យា និងវិស្វកម្មព័ត៌មាន (ITE) នៅសាកលវិទ្យាល័យភូមិន្ទភ្នំពេញ។",
      "ខ្ញុំចេះប្រើ C, C++, Python, HTML, CSS, JavaScript, Sass, Node.js, React.js, Vue.js, PHP, Laravel, MySQL, MongoDB, Firebase, Git, GitHub, Flask និង FastAPI ព្រមទាំងមានចំណេះដឹងផ្នែក Java, GraphQL និង Solidity ផងដែរ។",
      "ខ្ញុំចូលចិត្តធ្វើការជាមួយ Node.js, MongoDB និងក្របខ័ណ្ឌ JavaScript ទំនើបៗ ដូចជា React.js។",
      "ខ្ញុំក៏ចាប់អារម្មណ៍យ៉ាងខ្លាំងលើផ្នែកសន្តិសុខសាយប័រ ជាពិសេសការសាកល្បងវាយប្រហារតាមផ្លូវច្បាប់ (Ethical hacking) ហើយចូលចិត្តសិក្សាពីបញ្ញាសិប្បនិម្មិតដែរ។",
      "បច្ចុប្បន្ន ខ្ញុំជា​គ្រូបង្រៀនមុខ Information Communication Technology នៅក្នុងអង្គការមួយក្នុង ខេត្តសៀមរាប​ ហើយខ្ញុំក៏ជា Freelance FullStack Dev ផងដែរ។",
    ],
    factsLabels: {
      location: "ទីតាំង",
      role: "តួនាទី",
      focus: "ជំនាញគោល",
    },
    facts: {
      location: "សៀមរាប ប្រទេសកម្ពុជា",
      role: "បញ្ចប់​ បរិញ្ញាបត្រជំនាញ វិស្វកម្មបច្ចេកវិទ្យាព័ត៏មាននៅសកលភូមិន្ទភ្នំពេញ, បច្ចុប្បន្នជាគ្រូបង្រៀនជំនាញ​ ICT និង ជា Freelance FullStack Dev",
      focus:
        "អភិវឌ្ឍន៍វេបសាយ សន្តិសុខសាយប័រ រចនា UI/UX ​ គ្រូបង្រៀន ICT នឹងអ្នកសម្របសម្រួលបច្ចេកទេស GPS",
    },
    cards: {
      available: "គ្រូ ICT · Freelance Dev",
      education: "ការសិក្សា",
      stack: "បច្ចេកវិទ្យាដែលខ្ញុំប្រើ",
      passion: "អ្វីដែលជំរុញខ្ញុំ",
    },
    findMeOn: "ស្វែងរកខ្ញុំនៅ",
    connectText: "សូមកុំស្ទាក់ស្ទើរក្នុងការទាក់ទង និង",
    connectHighlight: "ភ្ជាប់ទំនាក់ទំនងជាមួយខ្ញុំ។",
  },
  focus: {
    label: "ជំនាញផ្តោត",
    heading: { a: "អ្វីដែលខ្ញុំ", highlight: "ធ្វើ" },
    marquee: ["React", "Node.js", "FastAPI", "Figma", "Laravel", "Vue.js", "MongoDB", "Tailwind CSS", "Python", "Cybersecurity", "UI/UX"],
    items: [
      { title: "អភិវឌ្ឍគេហទំព័រ Full-Stack", desc: "កម្មវិធីដោយប្រើ React, Node.js, FastAPI និង Laravel" },
      { title: "រចនា UI/UX", desc: "Wireframe, Prototype និង Design System ក្នុង Figma" },
      { title: "សន្តិសុខអ៊ីនធឺណិត", desc: "សុវត្ថិភាពគេហទំព័រ, Ethical Hacking និងមូលដ្ឋាន SOC" },
      { title: "បង្រៀន ICT", desc: "ជំនាញឌីជីថលជាក់ស្តែងសម្រាប់យុវជន" },
      { title: "ជំនួយបច្ចេកទេស", desc: "Hardware, បណ្តាញ និងការដោះស្រាយបញ្ហា" },
      { title: "បង្កើតគំរូ (Prototyping)", desc: "ពីគំនិត ទៅជាគំរូដែលអាចចុចសាកល្បងបាន យ៉ាងរហ័ស" },
    ],
  },
  skillset: {
    heading1: { a: "ជំនាញ", highlight: "វិជ្ជាជីវៈ" },
    heading2: { highlight: "ឧបករណ៍", b: "ដែលខ្ញុំប្រើ" },
    githubHeading: { a: "ថ្ងៃដែលខ្ញុំ", highlight: "សរសេរកូដ" },
    githubSubheading: "សកម្មភាពចូលរួមផ្ទាល់ ដកស្រង់ចេញពី GitHub របស់ខ្ញុំ។",
    githubLinkText: "មើលគណនី GitHub",
  },
  projects: {
    label: "ស្នាដៃ",
    tags: { live: "គេហទំព័រផ្ទាល់", code: "កូដ", design: "រចនា UI/UX" },
    heading: { a: "ស្នាដៃ", highlight: "ថ្មីៗបំផុត" },
    subheading: "នេះជាគម្រោងមួយចំនួនដែលខ្ញុំបានធ្វើថ្មីៗនេះ។",
    footerNote:
      "ចង់ឃើញស្នាដៃរបស់ខ្ញុំបន្ថែមទៀត? សូមចូលមើល GitHub ឬបណ្តាញសង្គមរបស់ខ្ញុំ — សូមអរគុណ!",
    ghButton: "GitHub",
    demoButton: "សាកល្បង",
    items: {
      theWalk: {
        title: "TheWalk",
        description:
          "គេហទំព័រលក់ដូរអនឡាញដែលខ្ញុំបានសាងសង់ក្នុងឆមាសទី១ ឆ្នាំទី៣ ជាកន្លែងឱ្យអតិថិជនទិញស្បែកជើងតាមអនឡាញ ស្រដៀងនឹងគេហទំព័រអេឡិចត្រូនិចផ្សេងទៀត។",
      },
      blogger: {
        title: "គេហទំព័រ Blogger",
        description:
          "ប្លុកមួយដែលខ្ញុំបានសាងសង់លើ Blogger សម្រាប់ដាក់ស្នាដៃការងារបញ្ជូនទៅសាស្ត្រាចារ្យ។",
      },
      fastapi: {
        title: "គម្រោង FastAPI",
        description:
          "កិច្ចការសិក្សាមួយពីឆ្នាំទី២ ដែលខ្ញុំបានសាងសង់ដោយប្រើ FastAPI សម្រាប់សាស្ត្រាចារ្យ។",
      },
      meakutes: {
        title: "Meakutes Khmer",
        description:
          "គេហទំព័រសម្រាប់ស្វែងរកទីកន្លែងទេសចរណ៍នៅកម្ពុជា។ ខ្ញុំបានធ្វើរួចតែផ្នែក UI/UX ប៉ុណ្ណោះ ហើយគម្រោងមិនទាន់ចប់ទេ — ខ្ញុំគ្រោងបញ្ចប់វានៅចុងឆមាស។",
      },
      walkFigma: {
        title: "TheWalk — គំនិត UI លើ Figma (កំណែទី១)",
        description:
          "គម្រោងឆមាសទី១ ឆ្នាំទី៣ របស់ខ្ញុំនៅ ITE។ ក្រុមរបស់ខ្ញុំមានសមាជិកបួននាក់ ប៉ុន្តែសម្របសម្រួលគ្នាមិនសូវរលូន ដូច្នេះខ្ញុំក៏ប្តូរផែនការមកធ្វើម្នាក់ឯងវិញ។",
      },
      firstUiUx: {
        title: "ការរចនា UI/UX ដំបូងរបស់ខ្ញុំ",
        description:
          "គម្រោង Figma ដំបូងគេរបស់ខ្ញុំ ធ្វើឡើងក្នុងកំឡុងពេលរៀន Figma។",
      },
      teacherAssistant: {
        title: "Teacher Assistant",
        description:
          "វេទិកាគេហទំព័រដែលខ្ញុំបានសាងសង់ជាមួយក្រុមប្រាំនាក់ ដោយប្រើ Vue.js ភ្ជាប់ជាមួយ Laravel Framework — សូមចូលមើលផងណា!",
      },
      car3d: {
        title: "ហ្គេម Car3D",
        description: "គម្រោង C++ ដែលកែសម្រួលចេញពីប្រភពក្រៅប្រទេស។",
      },
      kroeungtes: {
        title: "KroeungTes UI/UX",
        description:
          "គម្រោងឆ្នាំទី៤ របស់ខ្ញុំសម្រាប់មុខវិជ្ជា Mobile Development ឆមាសទី២។",
      },
      BookSelling: {
        title: "ReanPhysic",
        description:
          "គេហទំព័រនេះ​ ខ្ញុំបានបង្កើតសម្រាប់អតិថិជនម្នាក់ ដែលគាត់ចង់បង្កើតគេហទំព័រសម្រាប់អាជីវកម្មរបស់គាត់។ គេហទំព័រនេះត្រូវបានបង្កើតឡើងដោយប្រើ React.js និង Tailwind CSS ហើយវាត្រូវបានផ្ទុកនៅលើ Claudeflare & Render សម្រាប់ Hosting Server។",
      },
      MyPortfolioWebsite: {
        title: "My Portfolio Website",
        description:
          "នេះគឺជាគេហទំព័រផ្ទាល់ខ្លួនរបស់ខ្ញុំ ដែលខ្ញុំបានបង្កើតឡើងដើម្បីបង្ហាញជំនាញ ស្នាដៃ និងបទពិសោធន៍របស់ខ្ញុំ។ វាត្រូវបានបង្កើតឡើងដោយប្រើ React.js និង Tailwind CSS ហើយវាត្រូវបានផ្ទុកនៅលើ Claudeflare។",
      },
      meakuteswebsitedemo: {
        title: "Meakutes Website Demo",
        description:
          "នេះគឺជាគេហទំព័រដែលខ្ញុំបានបង្កើតឡើងសម្រាប់ផ្សព្វផ្សាយទេសចរណ៍កម្ពុជា ក្នុងអំឡុងពេលជំងឺ COVID-19។",
      },
    },
  },
  resume: {
    downloadButton: "ទាញយកប្រវត្តិរូប",
    loadError: "មិនអាចបង្ហាញឯកសារ PDF បានទេ — សូមចុចប៊ូតុងទាញយកខាងក្រោម។",
    loading: "កំពុងផ្ទុកប្រវត្តិរូប...",
  },
  contact: {
    heading: { a: "ទាក់ទង", highlight: "មកខ្ញុំ" },
    lead: "មានសំណួរ ឬចង់សហការជាមួយខ្ញុំ? សូមផ្ញើសារមក ខ្ញុំនឹងឆ្លើយតបវិញ។",
    namePlaceholder: "ឈ្មោះរបស់អ្នក",
    emailPlaceholder: "អ៊ីមែលរបស់អ្នក",
    messagePlaceholder: "សាររបស់អ្នក",
    sendButton: "ផ្ញើសារ",
    notDone: "សូមបំពេញគ្រប់ប្រអប់ទាំងអស់។",
    done: "អរគុណសម្រាប់ការទាក់ទង! ខ្ញុំបានទទួលសាររបស់អ្នកហើយ។",
  },
  footer: {
    localTime: "ម៉ោងក្នុងស្រុក",
    location: "សៀមរាប, កម្ពុជា",
    cta: "មានគម្រោងក្នុងចិត្តមែនទេ?",
    ctaLink: "តោះនិយាយគ្នា",
    madeWith: "បង្កើតដោយ ☕ នៅសៀមរាប",
    dept: "ដេប៉ាតឺម៉ង់បច្ចេកវិទ្យា និងវិស្វកម្មព័ត៌មាន",
    copyright: "រក្សាសិទ្ធិ ©",
  },
};

export default km;
